import "@/App.css";
import "@/premium.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PremiumHomePage from "./pages/PremiumHomePage";
import FranchisingPage from "./pages/FranchisingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PremiumHomePage />} />
          <Route path="/franchising" element={<FranchisingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
